import axios from 'axios'
import md5 from 'js-md5'
import httpBuildQuery from 'locutus/php/url/http_build_query'
import ksort from 'locutus/php/array/ksort'
import urldecode from 'locutus/php/url/urldecode'

// create axios
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api base_url
  timeout: 50000, // timeout,
  headers: { 'Access-Control-Allow-Origin': '*' }
})

const err = error => {
  const { status, data } = error.response
  const { errors } = data
  let message = []
  for (let field in errors) {
    message.push(errors[field])
  }
  switch (status) {
    case 400:
      this.$message({
        showClose: true,
        message: data.message,
        type: 'error'
      })
      break

    case 422:
      this.$message({
        showClose: true,
        message: message,
        type: 'error'
      })
      break
    default:
      this.$message({
        showClose: true,
        message: 'SERVER_ERROR',
        type: 'error'
      })
      break
  }

  return Promise.reject(error)
}

// calcSign
const calcSign = (data, signKey, timestamp) => {
  // console.log('data:', data)

  ksort(data)
  console.log('data:', data)
  let kvStr = httpBuildQuery(data)
  // console.log('str:', kvStr)

  kvStr = urldecode(kvStr)
  let sign = md5(kvStr + timestamp).toString()
  // console.log('sign(kvStr + timestamp):', kvStr + timestamp, sign)

  sign = md5(sign + signKey).toString()
  // console.log('sign(+ signKey):', sign)

  return sign
}

// request interceptor

service.interceptors.request.use(config => {
  config.headers['Access-Control-Allow-Origin'] = '*'
  config.headers['Content-Type'] = 'application/json'
  config.data = config.data || {}

  let signKey = '9feqni11w9zlm67xuv4vegxtmhowsa11'

  let timestamp = Date.parse(new Date()) / 1000
  let sign = calcSign(config.data, signKey, timestamp)
  // console.log('sign ', sign)
  config.url = `${config.url}?timestamp=${timestamp}&sign=${sign}&channel=lm67`

  return config
}, err)

// response interceptor

service.interceptors.response.use(({ data, config }) => {
  let reLogin = [
    10010001,
    10010003,
    10010004,
    10010014,
    10000037,
    10010015,
    10010016,
    10010017
  ]

  if (reLogin.includes(data.code)) {
    this.$message({
      showClose: true,
      message: data.msg,
      type: 'error'
    })
  }

  if (
    ['put', 'post', 'delete', 'patch'].includes(config.method) &&
    data.code === 0
  ) {
    // window._VMA.$emit('SHOW_SNACKBAR', {
    //   text: data.msg,
    //   color: 'success'
    // })
  }

  if (data.code !== 0) {
    this.$message({
      showClose: true,
      message: data.msg,
      type: 'error'
    })
  }
  console.log('response', data)
  return data
}, err)

export default service



// WEBPACK FOOTER //
// ./src/util/request.js